import { sendTracking } from '../../js/tracking';

class ProductSupportTeaserSlider {
    constructor (element, options) {
        const defaults = {
            trackingAttr: 'data-trackingcategory'
        };

        this.settings = Object.assign({}, defaults, options);
        this.resizeHandler = options.resizeHandler;

        this.$slider = element;
        this.trackingCategory = this.$slider.getAttribute(this.settings.trackingAttr);
        this.currentIndex = 0;

        this.teaserSlider = undefined;

        this.$backButton = document.querySelector('.product-support-overview-back');
    }

    resizeProductSupportTeaser () {
        this.initialize();
        this.resizeHandler.customFunctions.push(() => {
            this.initialize();
        });
    }

    initialize () {
        const windowWidth = window.innerWidth;

        this.reinitSlider();

        if (windowWidth < 768) {
            if (!this.teaserSlider) {
                this.createSlider();
            }
        } else {
            this.destroySlider();
        }
    }

    createSlider () {
        const handleSlider = (Slider) => {
            let clicked = false;
            this.teaserSlider = new Slider(this.$slider, {
                breakpoints: null,
                speed: 500,
                indicators: true,
                prevnext: true,
                slidesPerView: 1,
                initAttr: 'data-productsupportteaserslider',
                onSlideChange: ($slider, slider, $currentSlide, currentIndex) => {
                    if (this.trackingCategory !== null) {
                        let direction;
                        if (currentIndex > this.currentIndex) {
                            direction = 'forth';
                        } else {
                            direction = 'back';
                        }

                        if (clicked === false) {
                            sendTracking({
                                category: this.trackingCategory,
                                action: 'swipe',
                                label: 'slide_' + direction + '_' + (currentIndex + 1)
                            });
                        }

                        this.currentIndex = currentIndex;
                        clicked = false;
                    }
                }
            });
        };

        import('../../components/slider/slider').then(({ Slider }) => {
            handleSlider(Slider);
        });
    }

    destroySlider () {
        if (this.teaserSlider) {
            this.teaserSlider.destroy();
            this.teaserSlider = undefined;
            const $swiperControls = this.$slider.querySelector('.swiper-controls');
            if ($swiperControls) {
                $swiperControls.remove();
            }
        }
    }

    reinitSlider () {
        if (this.$backButton) {
            this.$backButton.addEventListener('click', () => {
                const windowWidth = window.innerWidth;
                if (windowWidth < 768) {
                    this.destroySlider();
                    setTimeout(() => {
                        this.createSlider();
                    }, 500);
                }
            });
        }
    }
}

export { ProductSupportTeaserSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$productSupportTeaserSliders = $context.querySelectorAll('[data-productsupportteaserslider="slider"]');

        if ($$productSupportTeaserSliders.length > 0) {
            for (let i = 0; i < $$productSupportTeaserSliders.length; i++) {
                const $productSupportTeaserSlider = new ProductSupportTeaserSlider($$productSupportTeaserSliders[i], {
                    resizeHandler: window.resizeHandler
                });
                $productSupportTeaserSlider.resizeProductSupportTeaser();
            }
        }
    }
});
